
import React, { createContext, useContext, useEffect, useState } from "react";

const DoctorContext = createContext();

export const DoctorProvider = ({ children, initialDoctor }) => {
    const [selectedDoctor, setSelectedDoctor] = useState(initialDoctor);

    useEffect(() => {
        const doctor = localStorage.getItem("doctor")
        if (!doctor) return;
        setSelectedDoctor(JSON.parse(doctor))
    }, [])

    return (
        <DoctorContext.Provider
            value={{
                selectedDoctor,
                setSelectedDoctor,
            }}
        >
            {children}
        </DoctorContext.Provider>
    );
};

export const useDoctor = () => useContext(DoctorContext);